/* eslint array-callback-return: 0 */
// Had to turn this off because for some reason eslint was picking up a map that doesn't exist on this file.
/* global GM_STATE */

import { useMemo, useState } from 'preact/hooks'
import register from 'preact-custom-element'
import clsx from 'clsx'

const GLOBAL_HEADERS = ['Baby', 'Toddler', 'Younger', 'Older']
const GLOBAL_SUB_HEADERS = ['Foot Length (CM)', 'UK', 'US', 'EU']
const isPDP = () => window.location.href.includes('/products/')

const listObject = (l) => ({
  type: l.type,
  category: l.category,
  values: l.values
})
/**
 * version_two_size_data
 * [{
    "type" : string
    "category" : string
    "values" : string[]
 * }]
 */
const parseVersionTwo = (list) => {
  if (!list || !list?.length) {
    return {
      data: {},
      header: []
    }
  }

  const a = list.reduce((acc, l) => {
    const obj = listObject(l)
    const sizeKey = obj.type?.split(' ')?.shift() || 'Group'
    const subCategoryKey = obj.category

    /** Size category already exists in KV */
    if (acc[sizeKey]) {
      /** Check if the sub-category (Baby, Toddler, etc) exists */
      const object = acc[sizeKey]
      acc[sizeKey].push({
        title: subCategoryKey,
        data: obj.values
      })
      return acc
    }
    acc[sizeKey] = [
      {
        title: subCategoryKey,
        data: obj.values
      }
    ]
    return acc
  }, {})

  const sizeHeaderOptions = Object.keys(a)

  // sizeHeaderOptions.acc((acc, key, i) => {
  //   if (acc[key]) {
  //     if (acc[key][i]) {
  //       a[key].map((s, j) => console.log(key, s.data, j))
  //     }
  //     return acc
  //   }

  //   acc[key] = []
  // }, {})

  return {
    data: a,
    header: sizeHeaderOptions
  }
}

const SizeGuideHeader = ({ headings, category, callback, subTitleObject }) => {
  if (!headings.length) return <></>

  const sortedHeader = headings.sort((a, b) => {
    const indexA = GLOBAL_HEADERS.indexOf(a)
    const indexB = GLOBAL_HEADERS.indexOf(b)
    return indexA - indexB
  })

  return (
    <div class={'flex flex-row justify-between rounded-3xl bg-neutrals-base p-2'}>
      {sortedHeader.map((c) => {
        return (
          <div
            data-heading={c}
            onClick={callback}
            class={clsx(
              `relative flex w-full cursor-pointer flex-col justify-center p-2 text-center ${
                category === c ? 'rounded-3xl bg-white' : ''
              }`
            )}
          >
            <p class={clsx(`paragraph-sm font-bold ${category === c ? 'opacity-100' : 'opacity-55'}`)}>{c}</p>
            {!!subTitleObject[c] && <p className={'paragraph-xs'}>{subTitleObject[c]}</p>}
          </div>
        )
      })}
    </div>
  )
}

const SizeGuideTable = ({ category, data, links }) => {
  const table = data[category] ?? []
  if (!table.length) return <></>
  const sortedTable = table?.sort((a, b) => a?.title?.localeCompare(b?.title))
  const hasLinks = Object.keys(links[category] ? links[category] : {})?.length > 0

  return (
    <>
      <div class={'flex w-full flex-row justify-between pt-6'}>
        {sortedTable?.map((row) => {
          return (
            <div class={'flex w-full flex-col'}>
              <div class="relative flex cursor-pointer flex-col justify-center text-center">
                <p class="paragraph-sm font-bold">{row?.title}</p>
              </div>
            </div>
          )
        })}
        {!!hasLinks && (
          <div class={'flex w-full flex-col'}>
            <div class="relative flex cursor-pointer flex-col justify-center text-center">
              <p class="paragraph-sm font-bold"></p>
            </div>
          </div>
        )}
      </div>
      <div class={'flex w-full flex-row justify-between pt-6'}>
        {sortedTable?.map((c) => {
          return (
            <div class={'flex w-full flex-col'}>
              {c?.data?.map((v) => (
                <p className={'paragraph-sm border-t border-t-black py-4 text-center'}>{v}</p>
              ))}
            </div>
          )
        })}
        {/* Links table column, only renders on the generic size-guide page. */}
        {!!hasLinks && (
          <div class={'flex w-full flex-col'}>
            {links[category]?.map((c) => {
              return (
                <div class={'flex w-full flex-col'}>
                  <p className={'paragraph-sm border-t border-t-black py-4 text-center'}>
                    <a className={'font-bold text-primary-blue underline'} href={c?.url}>
                      {c?.title}
                    </a>
                  </p>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </>
  )
}

const SORT_ARR = ['CM', 'US', 'UK', 'EU']
const sortData = (data, category) => {
  // Iterate over each category (e.g., "Baby", "Toddler", "Kids")

  // Sort the category data based on the index in SORT_ARR
  const s = data[category].sort((a, b) => {
    const indexA = GLOBAL_SUB_HEADERS.indexOf(a.title)
    const indexB = GLOBAL_SUB_HEADERS.indexOf(b.title)
    return indexA - indexB // Sort based on the order in SORT_ARR
  })

  return s
}

const getMaxArray = (selected) => {
  return selected.reduce((acc, s) => {
    const len = s.data.length
    if (len > acc) {
      acc = len
      return acc
    }

    return acc
  }, 0)
}

const SizeGuideTableV2 = ({ category, data, links }) => {
  const table = data[category] ?? []
  if (!table.length) return <></>
  const sortedTable = table?.sort((a, b) => a?.title?.localeCompare(b?.title))
  const hasLinks = Object.keys(links[category] ? links[category] : {})?.length > 0

  const sizeTable = sortData(data, category)
  const largestArray = getMaxArray(sizeTable)
  const columnCount = sizeTable.length
  const indexData = Array.from(new Array(columnCount)).map((_, i) => i)
  const topData = Array.from(new Array(largestArray)).map((_, i) => i)

  return (
    <table border="1" style={{ borderCollapse: 'collapse', textAlign: 'center', width: '100%', border: 'none' }}>
      <thead className={'border-none'}>
        {sizeTable.map((s, i) => {
          return (
            <th className={'w-[20%]'}>
              <td className={'m-auto flex w-fit justify-center border-none'}>
                <div className={'py-4'}>{s.title}</div>
              </td>
            </th>
          )
        })}
        {!!hasLinks && (
          <th>
            <td class="relative flex cursor-pointer flex-col justify-center text-center">
              <p class="paragraph-sm font-bold"></p>
            </td>
          </th>
        )}
      </thead>
      <tbody className={'border-none'}>
        {topData.map((_, k) => {
          return (
            <tr className={'border-t border-solid border-t-black'}>
              {indexData.map((__, j) => {
                return (
                  <td className={'border-none'}>
                    <div className={'py-4 font-normal'}>{sizeTable[j]?.data[k] ?? ''}</div>
                  </td>
                )
              })}
              {!!hasLinks && (
                <>
                  <td className={'paragraph-sm border-t border-t-black py-4 text-center'}>
                    <a className={'font-bold text-primary-blue underline'} href={links[category][k]?.url ?? '#'}>
                      {links[category][k]?.title ?? ''}
                    </a>
                  </td>
                </>
              )}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

const parseCtaColumnData = (list) => {
  if (!list || isPDP()) return {}
  return list.reduce((acc, link) => {
    const key = link.category
    const object = {
      title: link.title,
      url: link.url
    }
    if (acc[key]) {
      acc[key].push(object)
      return acc
    }
    acc[key] = [object]
    return acc
  }, {})
}

function ProductSizeGuideV2() {
  const config = useMemo(() => {
    /**
     * Data: {
     *      [key]: {
     *           [key]: string[]
     *           }
     *      }
     * header : string[]
     */

    const { data, header } = parseVersionTwo(version_two_size_data)
    // eslint-disable-next-line camelcase
    const sizeGuideCTA = parseCtaColumnData(size_guide_links)

    // eslint-disable-next-line camelcase
    const subTitleObject = size_guide_header_subtitles
    return {
      data,
      header,
      sizeGuideCTA,
      subTitleObject
    }
  })
  const [category, setCategory] = useState(() => {
    if (!config.header.length) return ''
    return config.header[0]
  })
  const handleSetCategoryCallback = (event) => {
    const { dataset } = event.currentTarget
    const { heading } = dataset
    setCategory(heading)
  }

  return (
    <>
      <SizeGuideHeader
        headings={config.header}
        category={category}
        callback={handleSetCategoryCallback}
        subTitleObject={config.subTitleObject}
      />
      <SizeGuideTableV2 data={config.data} category={category} links={config.sizeGuideCTA} />
    </>
  )
}

register(ProductSizeGuideV2, 'x-product-size-guide')
